import { CentiosConfiguration, Centios } from './Centios';
import CentiosContent from './centios.config.json';

if (!CentiosContent.hosts) {
	throw new Error('`hosts` object is required in centios.config.json file');
}

const config = new CentiosConfiguration(CentiosContent.hosts);
global.Centios = new Centios(config);
